import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import MyLeave from "@/pages/MyLeave";
import SickLeave from "@/pages/SickLeave";
import TeamCalendar from "@/pages/TeamCalendar";
import ManagerReview from "@/pages/ManagerReview";
import Team from "@/pages/Team";
import { Toaster } from "@/components/ui/sonner";

function Protected({ children, managerOnly }) {
  const { user, ready } = useAuth();
  if (!ready || user === null)
    return <div className="min-h-screen grid place-items-center text-sm" style={{ color: "#6A736D" }}>Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (managerOnly && user.role !== "manager") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function LoginRoute() {
  const { user, ready } = useAuth();
  if (ready && user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/my-leave" element={<Protected><MyLeave /></Protected>} />
            <Route path="/sick-leave" element={<Protected><SickLeave /></Protected>} />
            <Route path="/calendar" element={<Protected><TeamCalendar /></Protected>} />
            <Route path="/review" element={<Protected managerOnly><ManagerReview /></Protected>} />
            <Route path="/team" element={<Protected managerOnly><Team /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
